import _extends from 'babel-runtime/helpers/extends';

import { rejectDemand } from '@/api/demand/demand';

export default {
  props: {
    dialog: {
      type: Object,
      required: true
    },

    currentDemand: {
      type: Object,
      require: true
    }
  },

  data: function data() {
    return {
      formConfig: {
        inline: false,
        labelPosition: 'right',
        labelWidth: '80px'
      },
      formItemList: [{
        label: '需求名称',
        prop: 'name',
        type: 'input',
        subtype: 'textarea',
        params: {
          disabled: true
        }
      }, {
        label: '需求说明',
        prop: 'instruction',
        type: 'input',
        subtype: 'textarea',
        params: {
          disabled: true
        }
      }, {
        label: '需求类型',
        prop: 'creation_types',
        type: 'input',
        params: {
          disabled: true
        }
      }, {
        label: '驳回原因',
        prop: 'reject_reason',
        type: 'input',
        subtype: 'textarea',
        rules: {
          required: true,
          message: '请输入驳回原因',
          trigger: 'change'
        },
        params: {
          autosize: { minRows: 2, maxRows: 6 },
          clearable: true,
          placeholder: '请输入驳回原因'
        }
      }],
      loading: false,
      form: {}
    };
  },


  watch: {
    'dialog.visible': function dialogVisible(val) {
      if (!val) {
        this.$refs.form.resetFields();
        this.$refs.form.clearValidate();
      }
    }
  },

  mounted: function mounted() {
    this.form = _extends({}, this.currentDemand, {
      reject_reason: ''
    });
  },


  methods: {
    handleSubmitReject: function handleSubmitReject() {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          rejectDemand(_this.currentDemand.id, {
            reject_reason: _this.form.reject_reason
          }).then(function (res) {
            _this.$message({ message: '驳回成功！', type: 'success' });
            _this.loading = false;
            _this.$emit('success');
          }).catch(function (err) {
            _this.loading = false;
            _this.$message({
              message: err.message || '驳回失败！',
              type: 'error'
            });
          });
        }
      });
    }
  }
};